import { i18n } from "../../../translate/i18n";
import { textFormatter } from "../../../utils/formatter/formatter";
import { CustomText } from "../../StyledComponents/styleComponents.index";
const { t } = i18n;

export const OrderDetailsHeader = ({ ctx, uiState }) => {
  const { upperLineInformation, bottomLineInformation } = ctx;
  const { shouldShowOrderId = false } = uiState || {};
  return (
    <section>
      <section style={{ display: 'flex', flexDirection: 'row', verticalAlign: "center", gap: '1rem' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.2rem' }}>
          <CustomText margin={0} color={"mediumGrey"} fontSize={['0.3rem', '0.8rem', '1rem']} weight={"bold"}>
            {textFormatter("Cidade")}:
          </CustomText>
          <span style={{ fontSize: '0.9rem', lineHeight: "initial" }}>
            {`${upperLineInformation?.city}`}
          </span>
        </div>

        <div style={{ display: 'flex', alignItems: 'center', gap: '0.2rem' }}>
          <CustomText margin={0} color={"mediumGrey"} fontSize={['0.3rem', '0.8rem', '1rem']} weight={"bold"}>
            {textFormatter(t("store"))}:
          </CustomText>
          <span style={{ fontSize: '0.9rem', lineHeight: "initial" }}>
            {`${upperLineInformation?.name}`}
          </span>
        </div>

        <div style={{ display: 'flex', alignItems: 'center', gap: '0.2rem' }}>
          <CustomText margin={0} color={"mediumGrey"}  fontSize={['0.3rem', '0.8rem', '1rem']} weight={"bold"}>
              {textFormatter("cnpj", { textTransform: 'uppercase' })}:
            </CustomText>
          <span style={{ fontSize: '0.9rem' }}>{textFormatter(upperLineInformation?.cnpj)}</span>
        </div>

        <div style={{ display: 'flex', alignItems: 'center', gap: '0.2rem' }}>
          <CustomText color={"mediumGrey"}  fontSize={['0.3rem', '0.8rem', '1rem']} weight={"bold"}>
            {textFormatter(t("address"))}:
          </CustomText>
          <span style={{ fontSize: '0.9rem', lineHeight: "initial" }}>{textFormatter(upperLineInformation?.address, { textTransform: "none" })}</span>
        </div>      
      </section>

      <hr style={{ inlineSize: "100%", borderTop: "1px solid black", margin: "0.5rem 0" }} />

      <section style={{ display: 'flex', flexDirection: 'column' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.2rem' }}>
          <CustomText margin={0} color={"mediumGrey"}  fontSize={['0.3rem', '0.8rem', '1rem']} weight={"bold"}>
              {textFormatter(t("supplier"))}:
            </CustomText>
          <span style={{ fontSize: '0.9rem', lineHeight: "initial" }}>
            {textFormatter(bottomLineInformation?.supplierName, { textTransform: 'uppercase'} )}
          </span>
        </div>

        <div style={{ display: 'flex', alignItems: 'center', gap: '0.2rem' }}>
          <CustomText margin={0} color={"mediumGrey"}  fontSize={['0.3rem', '0.8rem', '1rem']} weight={"bold"}>
            {textFormatter(t("orderGeneratedBy"))}:
          </CustomText>
          <span style={{ fontSize: '0.9rem', lineHeight: "initial" }}>
            {textFormatter(bottomLineInformation?.name)}
          </span>
        </div>

        <div style={{ display: 'flex', alignItems: 'center', gap: '0.2rem' }}>
          <CustomText margin={0} color={"mediumGrey"}  fontSize={['0.3rem', '0.8rem', '1rem']} weight={"bold"}>
            {textFormatter(t("orderDate"))}:
          </CustomText>
          <span style={{ fontSize: '0.9rem', lineHeight: "initial" }}>
            {textFormatter(bottomLineInformation?.orderDate)}
          </span>
        </div>

        {shouldShowOrderId && (
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.2rem' }}>
            <CustomText color={"mediumGrey"}  fontSize={['0.3rem', '0.8rem', '1rem']} weight={"bold"}>
              {textFormatter("Número do pedido")}:
            </CustomText>
            <span style={{ fontSize: '0.9rem' }}>{textFormatter(String(bottomLineInformation?.orderId))}</span>
          </div>
        )}    
      </section>
    </section>
  );
};